import { i18n } from '@/setup/i18n-setup'
import axios from 'axios'
const Trans = {
  get defaultLocale () {
    return process.env.VUE_APP_I18N_LOCALE
  },
  get supportedLocales() {
    return this.supportedLocalesArray.map(locale => locale.id)
  },
  get supportedLocalesArray() {
    return [
      {
        id: 'en',
        title: 'English',
        flagSrc: '/storage/app/media/flags/gb.svg'
      },
      {
        id: 'fr',
        title: 'Français',
        flagSrc: '/storage/app/media/flags/fr.svg'
      }
    ]
  },
  getUserSupportedLocale() {
    const userPreferredLocale = Trans.getUserLocale()
    if (Trans.isLocaleSupported(userPreferredLocale.locale)) { // <------------- 2
      return userPreferredLocale.locale
    }
    if (Trans.isLocaleSupported(userPreferredLocale.localeNoISO)) { // <------------- 3
      return userPreferredLocale.localeNoISO 
    }
    return Trans.defaultlocale // <------------- 4
  },
  getUserLocale() {
    const locale = localStorage.locale || window.navigator.language || window.navigator.userLanguage || Trans.defaultLocale// <----------- 1
    return {
      locale: locale, //<-------------- 2
      localeNoISO: locale.split('-')[0] //<------------- 3
    }
  },
  get currentLocale() {
    return i18n.locale
  },
  set currentLocale(locale) {
    i18n.locale = locale
  },
  changeLocale(locale) {
    
    if (!Trans.isLocaleSupported(locale)) return Promise.reject(new Error('Locale not supported'))
    if (i18n.locale === locale) return Promise.resolve(locale)
    return Trans.loadLocaleFile(locale).then(msgs => {
      
      i18n.setLocaleMessage(locale, msgs.default || msgs)
      return Trans.setI18nLocaleInServices(locale)
    })
  },
  isLocaleSupported(locale) {
    return Trans.supportedLocales.includes(locale)
  },
  loadLocaleFile(locale) {
    return import(`@/lang/${locale}.json`)
  },
  setI18nLocaleInServices(locale) {
    Trans.currentLocale = locale
    localStorage.setItem("locale", `${locale}-${locale.toUpperCase()}`);
    axios.defaults.headers.common['Accept-Language'] = locale
    document.querySelector('html').setAttribute('lang', locale)
    return locale
  },
  routeMiddleware(to, from, next) {
    const locale = to.params.locale
    if (!Trans.isLocaleSupported(locale)) return next(Trans.getUserSupportedLocale())

    return Trans.changeLocale(locale).then(() => next())
  },
  i18nRoute(to) {
    return {
      ...to,
      params: {locale: this.currentLocale, ...to.params}
    }
  }
}

export { Trans }